import React from "react";
import "../Assets/Styles.css";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Divider from "@material-ui/core/Divider";
import MyCard from "../Components/MyCard";
import PowerApps from "../Assets/powerapps.png";
import PowerAutomate from "../Assets/powerautomate.png";
import Dataverse from "../Assets/dataverse.png";
import Chip from "@material-ui/core/Chip";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "space-around",
    flexWrap: "wrap",
    "& > *": {
      margin: theme.spacing(1),
      width: "300px",
      height: "300px",
    },
  },
  PaperClass: {
    border: "solid white 1px",
    backgroundColor: "#2a2b3d",
    borderRadius: "10px",
    maxWidth: "80%",
  },
}));

const SkillsList = [
  {
    Logo: Dataverse,
    Name: "Dataverse",
    Score: 5,
    Link: "https://powerplatform.microsoft.com/dataverse/",
  },
  {
    Logo: "https://img.icons8.com/color/480/000000/office-365.png",
    Name: "Office 365",
    Score: 4.5,
    Link: "https://www.microsoft.com/es-ww/microsoft-365",
  },
  {
    Logo: PowerApps,
    Name: "PowerApps",
    Score: 5,
    Link: "https://powerapps.microsoft.com/",
  },
  {
    Logo: PowerAutomate,
    Name: "Power Automate",
    Score: 5,
    Link: "https://flow.microsoft.com/",
  },
  {
    Logo: "https://img.icons8.com/color/480/000000/python--v1.png",
    Name: "Python",
    Score: 1,
    Link: "https://www.python.org/",
  },
  {
    Logo: "https://img.icons8.com/color/480/000000/react-native.png",
    Name: "React",
    Score: 4,
    Link: "https://reactjs.org/",
  },
  {
    Logo: "https://img.icons8.com/color/480/000000/microsoft-sql-server.png",
    Name: "SQL",
    Score: 3,
    Link: "https://www.w3schools.com/sql/",
  },
];

function Skills() {
  const classes = useStyles();
  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
  return (
    <div style={{ marign: 0,height:'100%',border:'solid rgba(0, 0, 0, 0)' }}>
      <Typography variant="h2" component="h2" gutterBottom className="Header">
        SKILLS
      </Typography>
      <Divider />
      <div className={classes.root}>
        {SkillsList.map((item) => {
          return (
            <MyCard
              logo={item.Logo}
              Name={item.Name}
              Score={item.Score}
              Link={item.Link}
            />
          );
        })}
      </div>

      <div>
        <Divider />
        <Typography
          variant="h4"
          component="h4"
          gutterBottom
          className="Header"
          style={{ margin: "20px", marginBottom: "10px" }}
          color="secondary1"
        >
          OTHER
        </Typography>

        <div
          style={{
            display: "flex",
            marginLeft: "5%",
            overflow: "auto",
            marginBottom: "20px",
            maxWidth: "80%",
            minHeight: "50px",
          }}
        >
         
          <Chip
            label="Scrum Framework"
            clickable
            color="secondary"
            variant="outlined"
            style={{
              margin: "0px 8px",
              color: prefersDarkMode ? "#ffbc42" : "#16213E",
              borderColor: prefersDarkMode ? "#ffbc42" : "#16213E",
            }}
          />
          <Chip
            label="Project Management"
            clickable
            color="secondary"
            variant="outlined"
            style={{
              margin: "0px 8px",
              color: prefersDarkMode ? "#ffbc42" : "#16213E",
              borderColor: prefersDarkMode ? "#ffbc42" : "#16213E",
            }}
          />
          <Chip
            label="Continuous Learning"
            clickable
            color="secondary"
            variant="outlined"
            style={{
              margin: "0px 8px",
              color: prefersDarkMode ? "#ffbc42" : "#16213E",
              borderColor: prefersDarkMode ? "#ffbc42" : "#16213E",
            }}
          />
          <Chip
            label="ITIL Foundation Practices"
            clickable
            color="secondary"
            variant="outlined"
            style={{
              margin: "0px 8px",
              color: prefersDarkMode ? "#ffbc42" : "#16213E",
              borderColor: prefersDarkMode ? "#ffbc42" : "#16213E",
            }}
          />
          <Chip
            label="Results Focus"
            clickable
            color="secondary"
            variant="outlined"
            style={{
              margin: "0px 8px",
              color: prefersDarkMode ? "#ffbc42" : "#16213E",
              borderColor: prefersDarkMode ? "#ffbc42" : "#16213E",
            }}
          />
         
        </div>
      </div>
    </div>
  );
}

export default Skills;
